import sortData from './sortData';
import { isNotNullOrEmpty } from '@pcty/utils';
/**
 * Sorts a dataset and returns the slice of data that is the current page
 *
 * @category Sorting
 * @template T=unknown
 * @param {T[]} data The full dataset to page
 * @param {TablePageConfig} pageConfig The sorting config object shaped like { page, size, sorting: { keys, direction } }
 * @returns {T[]} The page of data to be displayed
 * @example
 * import { getDisplayedData } from '@citrus/data-table';
 * import { sortReduceString } from `@pcty/utils`;
 *
 * const data = [{ id: 1, hero: 'Batman' }, { id: 2, hero: 'Superman' }];
 * const pageConfig = {
 *   page: 1,
 *   size: 25,
 *   sorting = {
 *     keys: [sortReduceString('hero')],
 *     direction: 'asc',
 *   }
 * };

 * getDisplayedData(data, pageConfig);
 */
export default (function (data, config) {
    var _data = isNotNullOrEmpty(config.sorting) ? sortData(data, config.sorting) : data;
    if (config.size <= -1 || (isNotNullOrEmpty(config.limit) && config.limit <= -1))
        return _data;
    // if limit and offset are specified, use those values instead
    if (isNotNullOrEmpty(config.offset) && config.offset > -1 && isNotNullOrEmpty(config.limit) && config.limit > -1) {
        return _data.slice(config.offset, config.limit + config.offset);
    }
    var _page = config.page - 1; // because pages logically start with 1, but technically with 0
    return _data.slice(_page * config.size, (_page + 1) * config.size);
});
